// 实例请参考：
// 1.http://localhost:8080/#/home  这个是普通单页缓存
// 2.http://localhost:8080/#/football 这个是列表缓存demo
// 
// get请求会自动缓存，如不需要传入cache = false
export default class Cache {
    constructor(axios, config = {}) {
        this.axios = axios
        this.caches = []
        if (!this.axios) {
            throw new Error('请传入axios实例')
        }
        this.config = config
        // this.defaultConfig = {
        //     cache: true,
        //     expire: 5,
        //     isList:false,
        //     isClear:false //清除对应缓存
        // }
        this.CancelToken = this.axios.CancelToken
        this.init()
    }

    init() {
        this.requestInterceptor(this.config.requestInterceptorFn)
        this.responseInterceptor(this.config.responseInterceptorFn)
        window.onbeforeunload = () => {
            this.mapStorage()
        }
    }

    requestInterceptor(callback) {
        this.axios.interceptors.request.use(async config => {
            let newConfig = callback && (await callback(config))
            config = newConfig || config
            return config
        }, error => {
            return Promise.reject(error)
        })
    }

    responseInterceptor(callback) {
        this.axios.interceptors.response.use(async response => {
            let newResponse = callback && (await callback(response))
            response = newResponse || response
            // the http request error, do not store the result, direct return result
            if (response.status !== 200 || response.code <= 0) {
                return response.data
            }
            /*
             * `data` is the data to be sent as the request body, only applicable for request methods 'PUT', 'POST', and 'PATCH'
             * `params` are the URL parameters to be sent with the request, can be applicable for request methods 'GET'
             */
            let { url,baseURL,data, cache, cacheMode, params,cacheKey } = response.config
            if (cache === true) {
                let obj = {
                    expire: this.getExpireTime(),
                    params,
                    data,
                    result: response.data
                }
                if (cache && cacheKey){
                    this.caches.push(cacheKey)
                    this.setStorage(cacheKey, obj,cacheMode) 
                }
            }
            return response.data
        }, error => {
            // 返回缓存数据
            if (this.axios.isCancel(error)) {
                // return Promise.resolve(error.message.result)
                return Promise.resolve('stop')
            }
            return Promise.reject(error)
        })
    }

    // removeCache(key,mode = 'sessionStorage'){
    //     let obj = window[mode];
    //      let orgKey = this.filterCache(key);
    //      if( obj.length > 0){
    //         for (var i = obj.length - 1; i >= 0; i--) {
    //             if (orgKey == this.filterCache(obj.key(i))){
    //                 this.clearStorage(obj.key(i));
    //             }
    //         };
    //      }
    // }

    // filterCache(key){
    //     let obj = key.split('?cacheParams=');
    //     let params = '';
    //     let url = obj[0];
    //     if (obj[1]){
    //         params = JSON.parse(obj[1]);
    //         delete params.page;
    //         params = JSON.stringify(params);
    //     }
    //     return `${url}?cacheParams=${params}`
    // }

    // 设置缓存
    setStorage(key, cache,mode = 'sessionStorage') {
        window[mode].setItem(key, JSON.stringify(cache))
    }

    // 获取缓存
    getStorage( key,mode = 'sessionStorage') {
        let data = window[mode].getItem(key)
        return JSON.parse(data)
    }

    // 设置过期时间
    getExpireTime() {
        return Date.now()
    }

    // 清空缓存
    clearStorage(key,mode = 'sessionStorage') {
        if (window[mode].getItem(key)) {
            window[mode].removeItem(key)
        }
    }

    // 清空没用到的缓存
    mapStorage(mode = 'sessionStorage') {
        let length = window[mode].length
        if (length) {
            for (let i = 0; i < length; i++) {
                let key = window[mode].key(i)
                if (!this.caches.includes(key) && key.includes('?cacheParams=')) {
                    window[mode].removeItem(key)
                }
            }
        }
    }
}




// WEBPACK FOOTER //
// ./src/box/cache.js